import { TypePolicy } from '@apollo/client'

const Appointment: TypePolicy = {
  keyFields: ['appointmentId'],
}

export default Appointment
